<template lang="pug">
    include /@ibkr/lib.common/src/icon/arrow
    include /@ibkr/lib.common/src/icon/color
    div(class="expandable-button", v-click-outside="close")
        ib-button(@click="open", class="custom-button-red dark-grey-text fw-400 fs6 menu-body")
            span(class="insetx-4") {{ selectedCurrency }}
                +icon-arrow-sort_down_filled
        div(v-if="showOptions", class="floating-options")
            div(class="currency-selectors")
                ib-row(v-for="(item, index) in items", :key="item.key")
                    ib-col
                        ib-button(@click="select(index)", width="100%", class="custom-button-currency", :class="{ 'active-button-currency' : item.value === selectedCurrency }") 
                            span(class="fw-400 grey-text") {{ $t(item.name) }}
                            span(v-if="item.value === selectedCurrency")
                                +icon-color-yes
</template>

<script>

import { mapState } from 'vuex';

export default {
    name: 'DropdownSelectCurrency',
    props: {
        items: {
            type: Array,
            required: true
        },
    },
    data() {
        return {
            showOptions: false,
        }
    },
    methods: {
        open() {
            if (!this.showOptions) {
                this.showOptions = true;
            } else {
                this.showOptions = false;
            }
        },
        close() {
            if(!this.showOptions) return;
            this.showOptions = false;
        },
        select(index) {
            // User selects same currency
            if (this.items[index].value === this.selectedCurrency) {
                this.close();
                return;
            }

            this.$emit('apply', 'currency', this.items[index].value);
            this.close();
        },
    },
    computed: {
        ...mapState(['currencies', 'selectedCurrency']),
    }
}
</script>

<style lang="less" scoped>
    @import "../less/globals.less";

    .expandable-button {
        position: relative;
        display: inline-block;

        @media (max-width:767px) {
            width: 100%;
        }
    }

    .floating-options {
        @media (max-width:767px) {
            width: 100%;
        }

        z-index: 1000;
        position: absolute;

        min-width: 16rem; /* 10 rem in design. Some root font difference. */
        left: 0px;
        top: 35 px;

        margin-top: 2px;
        padding: 8px 8px;
        border-radius: 0px;
        border-top: 3px solid @menu-popup-red;

        background-color: #fff;

        border-left: 1px solid rgba(0,0,0,.15);
        border-right: 1px solid rgba(0,0,0,.15);
        border-bottom: 1px solid rgba(0,0,0,.15);

        &:after {
            display: inline-block;
            position: absolute;
            top: -7px;
            left: 0px;
            right: auto;
            margin: 0px 0px 0px 15px;
            border-right: 5px solid transparent;
            border-left: 5px solid transparent;
            border-bottom: 5px solid @menu-popup-red;
            content: "";
        }

        .currency-selectors {
            max-height: 60vh;
            overflow-y: scroll;
            overflow-x: hidden;
        }
    }
</style>